<div>
	<div nz-row nzJustify="space-between" [ngClass]="{'m-b-24':isMobile}">
		<div class="b-title self-center">
			Beneficiaries
		</div>
		<div *ngIf="newTransferView && !cantManage" class="manage-beneficiaries">
			<ng-container *ngIf="!isMobile">
				<app-custom-button (click)="manageBenficiaries()" text="Manage Beneficiaries" type="default"></app-custom-button>
			</ng-container>
			<ng-container *ngIf="isMobile">
				<app-custom-button (click)="manageBenficiaries()" text="Manage Beneficiaries" type="link"></app-custom-button>
			</ng-container>
		</div>
	</div>
	<div class="mobile-margin-less">
		<div class="m-t-24">
			<div class="custom-floating-input m-t-24 m-b-16">
				<nz-input-group [nzPrefix]="searchIcon">
					<input [ngModel]="searchParams" (ngModelChange)="filterBeneficiaries($event)" class="custom-input filter-banks-input" id="account" nz-input
						placeholder="Search By Beneficiary Name" type="text" [nzBorderless]="true" />
				</nz-input-group>
			</div>
		</div>
		<div>
			<!-- <div class="m-t-40">
			<div class="all-beneficiary">
				All Beneficiaries
			</div>
		</div> -->
			<div *ngIf="filteredMoniepointBeneficiaries.length" class="max-h-[526px] overflow-y-scroll">
				<div (click)="selectedBeneficiary(beneficiary)" *ngFor="let beneficiary of filteredMoniepointBeneficiaries|searchFilter:searchParams:'beneficiaryName';let k = index"
					class="addCursor">
					<div class="beneficiary-row-bill-payment" nz-row nzAlign="middle" nzJustify="space-between">
						<div nz-row nzAlign="middle">
							<div class="beneficiary-box">
								{{getInitials(beneficiary?.beneficiaryName)}}
							</div>
							<div class="m-l-20">
								<div class="beneficiary-name">
									{{beneficiary?.beneficiaryName}}
								</div>
								<div class="beneficiary-value m-t-4">
									{{beneficiary?.customerIdName}}: {{beneficiary?.customerIdValue}}
								</div>
							</div>
						</div>
						<div *ngIf="isMobile">
							<app-icon icon="caret-right"></app-icon>
						</div>
						<div *ngIf="!isMobile" class="custom-radio-btn">
							<label (ngModelChange)="selectedBeneficiary(beneficiary)" [ngModel]="selectedBeneficiaryItem?.id === beneficiary.id" nz-radio></label>
						</div>
					</div>

					<div *ngIf="(filteredMoniepointBeneficiaries?.length - 1) !== k ">
						<div class="bill-payment-divider"></div>
					</div>

				</div>
			</div>
			<div class="flex justify-end m-t-16" *ngIf="!isMobile">
				<app-custom-button text="Back" type="link" (click)="closeModal()"></app-custom-button>
				<app-custom-button text="Confrim" type="default" [isDisabled]="!selectedBeneficiaryItem"
					(click)="confrimBeneficiary()"></app-custom-button>
			</div>
		</div>
	</div>
</div>
<ng-template #searchIcon>
	<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M21.9073 19.7527L17.4969 15.3422C18.5587 13.9286 19.1319 12.208 19.13 10.44C19.13 5.92406 15.4559 2.25 10.94 2.25C6.42406 2.25 2.75 5.92406 2.75 10.44C2.75 14.9559 6.42406 18.63 10.94 18.63C12.708 18.6319 14.4286 18.0587 15.8422 16.9969L20.2527 21.4073C20.4759 21.6069 20.7671 21.7135 21.0664 21.7051C21.3658 21.6967 21.6506 21.574 21.8623 21.3623C22.074 21.1506 22.1967 20.8658 22.2051 20.5664C22.2135 20.2671 22.1069 19.9759 21.9073 19.7527ZM5.09 10.44C5.09 9.28298 5.4331 8.15194 6.0759 7.18991C6.71871 6.22789 7.63235 5.47808 8.7013 5.03531C9.77025 4.59253 10.9465 4.47668 12.0813 4.70241C13.2161 4.92813 14.2584 5.48529 15.0766 6.30343C15.8947 7.12156 16.4519 8.16393 16.6776 9.29872C16.9033 10.4335 16.7875 11.6098 16.3447 12.6787C15.9019 13.7476 15.1521 14.6613 14.1901 15.3041C13.2281 15.9469 12.097 16.29 10.94 16.29C9.38906 16.2881 7.90217 15.6712 6.80548 14.5745C5.7088 13.4778 5.09186 11.9909 5.09 10.44Z"
			fill="#0B3275" fill-opacity="0.4" />
	</svg>
</ng-template>